import React from 'react'
// import DemoAlert from 'views/components/DemoAlert'
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Button,
  Input,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap'
import Switch from 'react-bootstrap-switch'
import {
  FormControl,
  FormLabel,
  FormGroup as MuiFormGroup,
  Checkbox,
  FormControlLabel,
  TextField,
  Autocomplete,
  Alert,
} from '@mui/material'
import { Calendar, momentLocalizer, Views } from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css'
import moment from 'moment-timezone'
import 'moment/locale/fi'
// Prompt was removed in React Router v6 - unsaved changes warning disabled
// import { Prompt } from 'react-router-dom'
import TinyEditor from '../Editor/TinyEditor'
import { v4 as uuidv4 } from 'uuid'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const TIMEZONE_OFFSET = new Date().getTimezoneOffset()

const localizer = momentLocalizer(moment)

const DnDCalendar = withDragAndDrop(Calendar)

const weekdaysAsResources = [
  { resourceId: 1, resourceTitle: 'Maanantai' },
  { resourceId: 2, resourceTitle: 'Tiistai' },
  { resourceId: 3, resourceTitle: 'Keskiviikko' },
  { resourceId: 4, resourceTitle: 'Torstai' },
  { resourceId: 5, resourceTitle: 'Perjantai' },
  { resourceId: 6, resourceTitle: 'Lauantai' },
  { resourceId: 7, resourceTitle: 'Sunnuntai' },
]

const CONFIRMATION_TYPES = [
  { value: 'reservation', label: 'Varaus' },
  { value: 'move', label: 'Siirto' },
  { value: 'cancellation', label: 'Peruutus' },
  { value: 'multireservation', label: 'Monipaikkavaraus' },
]

// One confirmation for a booking of N places on a multiresource (merged court). The backend
// matches `resources` against the multiresource's own id, not its member courts. Contract:
// falcon/functions docs/multireservation-confirmation-template.md
const MULTIRESERVATION = 'multireservation'

const MULTIRESERVATION_HELP = [
  ['{RESERVATION_GROUP}', 'Yhdistetyn kentän nimi'],
  ['{RESERVATION_AMOUNT}', 'Varattujen paikkojen määrä'],
  ['{RESERVATION_COURTS}', 'Varatut kentät'],
  ['{RESERVATION_UNIT_PRICE}', 'Hinta per paikka (tyhjä, jos hinnat eroavat)'],
  ['{RESERVATION_TOTAL_PRICE}', 'Kokonaishinta'],
]

const PricingToolBar = () => {
  return <></>
}

const INIT_TEMPLATE = {
  type: 'reservation',
  venue: 'all',
  lang: 'all',
  channel: 'mail',
  memberships: [],
  enabled: true,
  default: false,
  collection: 'reservation', // activity
  schedule: [],
  resources: [],
  message: {
    subject: '',
    body: '',
    htmlbody: '',
  },
}

const DEFAULT_CONFIRMATION_TEMPLATES = [
  {
    type: 'reservation',
    category: 'all',
    venue: 'all',
    lang: 'all',
    channel: 'mail',
    memberships: [],
    enabled: true,
    default: true,
    collection: 'reservation',
    message: {
      subject: 'Varausvahvistus {SUBJECT_SHORT}',
      body:
        'Hei {PERSON_NAME},\r\n\r\nVahvistetun varauksen tiedot,\r\n\r\n' +
        'Aika	{RESERVATION_DATE_TIME},\r\n\r\nPaikka	{RESERVATION_VENUE},\r\n\r\nKenttä	{RESERVATION_COURT} / {RESERVATION_SPORT} \r\n\r\nHinta	{RESERVATION_PRICE},\r\n\r\nTervetuloa!',
      htmlbody: '',
    },
  },
  {
    type: 'move',
    category: 'all',
    venue: 'all',
    lang: 'all',
    channel: 'mail',
    memberships: [],
    enabled: true,
    default: true,
    collection: 'reservation',
    message: {
      subject: 'Vuoron siirto {SUBJECT_SHORT}',
      body:
        'Hei {PERSON_NAME},\r\n\rSiirretyn varauksen tiedot,\r\n\r\n' +
        'Aika	{RESERVATION_DATE_TIME},\r\n\r\nPaikka	{RESERVATION_VENUE},\r\n\r\nKenttä	{RESERVATION_COURT} / {RESERVATION_SPORT} \r\n\r\nTervetuloa!',
      htmlbody: '',
    },
  },
  {
    type: 'cancellation',
    category: 'all',
    venue: 'all',
    lang: 'all',
    channel: 'mail',
    memberships: [],
    enabled: true,
    default: true,
    collection: 'reservation',
    message: {
      subject: 'Vuoron peruutus {SUBJECT_SHORT}',
      body:
        'Hei {PERSON_NAME},\r\n\rPeruutetun varauksen tiedot,\r\n\r\n' +
        'Aika	{RESERVATION_DATE_TIME},\r\n\r\nPaikka	{RESERVATION_VENUE},\r\n\r\nKenttä	{RESERVATION_COURT} / {RESERVATION_SPORT}',
        htmlbody: '',
    }
  },
  {
    // Suggested text from the backend contract; the backend itself has no fallback.
    type: MULTIRESERVATION,
    category: 'all',
    venue: 'all',
    lang: 'all',
    channel: 'mail',
    memberships: [],
    enabled: true,
    default: true,
    collection: 'reservation',
    message: {
      subject: 'Varausvahvistus {SUBJECT_SHORT}',
      body:
        'Hei {PERSON_NAME},\r\n\r\nVahvistetun varauksen tiedot,\r\n\r\n' +
        'Aika	{RESERVATION_DATE_TIME},\r\n\r\nPaikka	{RESERVATION_VENUE},\r\n\r\n' +
        'Varaus	{RESERVATION_GROUP} / {RESERVATION_SPORT}, {RESERVATION_AMOUNT} kpl\r\n\r\n' +
        'Hinta	{RESERVATION_PRICE},\r\n\r\nTervetuloa!',
      htmlbody: '',
    },
  },
]

// The backend has no built-in multireservation default: without a saved, enabled template a
// merged-court booking gets no confirmation at all.
const hasEnabledMultiReservation = (confirmations) =>
  (confirmations || []).some((c) => c.type === MULTIRESERVATION && c.enabled)

// Venues saved before the multireservation type existed get its default row shown as a
// suggestion; it only takes effect once saved (see the warning in render).
const withMultiReservationDefault = (confirmations) => {
  if (confirmations.some((c) => c.type === MULTIRESERVATION && c.default)) return confirmations
  const def = DEFAULT_CONFIRMATION_TEMPLATES.find((c) => c.type === MULTIRESERVATION)
  return [...confirmations, JSON.parse(JSON.stringify(def))]
}

function formatSchedule(schedule) {
  return schedule.map((s) => {
    return {
      id: s.id,
      start: moment('1970-01-01 ' + s.start).toDate(),
      end: moment('1970-01-01 ' + s.end).toDate(),
      resourceId: s.day,
    }
  })
}

function ConfirmationMessageRow(props) {
  const {
    index: i,
    template,
    openEditMessageModal,
    openEditScheduleModal,
    openEditResourcesModal,
    updateTemplateName,
    updateTemplateType,
    updateTemplateEnabled,
    isDefault,
  } = props

  return (
    <Row key={i} style={{ borderTop: '1px solid rgba(0, 0, 0, 0.10)', paddingTop: 15, paddingBottom: 5 }}>
      <Col md='3' xs='12'>
        <Autocomplete
          id={'label.' + i}
          options={CONFIRMATION_TYPES}
          getOptionLabel={(o) => o.label || ''}
          isOptionEqualToValue={(o, v) => o.value === v.value}
          disabled={template.default}
          value={template.type ? CONFIRMATION_TYPES.find((x) => x.value === template.type) || null : null}
          onChange={(_e, val) => updateTemplateType(val || CONFIRMATION_TYPES[0])}
          disableClearable
          renderInput={(params) => (
            <TextField {...params} label='Tyyppi' variant='standard' fullWidth />
          )}
        />
      </Col>
      <Col md='1' xs='12'>
        <Label for={'enabled.' + i}>Käytössä</Label>{' '}
        <div name={'enabled.' + i}>
          <Switch
            defaultValue={template.enabled || false}
            onColor='primary'
            offColor='primary'
            id={'enabled.' + i}
            name={'enabled.' + i}
            onChange={(e, s) =>updateTemplateEnabled(s)}
            disabled={template.default}
          />
        </div>
      </Col>
      <Col md='3' xs='12' style={{ paddingRight: 30 }}>
        <TextField
          fullWidth
          id={'diplayName.' + i}
          label='Nimi'
          value={
            template.default
              ? 'Oletusviesti. Tarkista sisältö'
              : template.displayName
              ? template.displayName
              : ''
          }
          disabled={template.default}
          onChange={updateTemplateName}
        />
      </Col>
      <Col>
        <Button color={'success'} onClick={() => openEditMessageModal(i)}>
          Viesti
        </Button>
        <Button
          disabled={isDefault}
          color={'success'}
          onClick={() => openEditScheduleModal(i)}
        >
          Aikataulu
        </Button>
        <Button
          disabled={isDefault}
          color={'success'}
          onClick={() => openEditResourcesModal(i)}
        >
          Resurssit
        </Button>
      </Col>
    </Row>
  )
}

class ConfirmationMessageTemps extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      confirmations: [],
      resourcecategories: [],
      resources: [],
      multiresources: [],
      categoryOptions: [],
      loadingTemplates: true,
      loadingCategories: true,
      loadingResources: true,
      saved: true,
      storedMultiReservation: true,
      showMessageModal: false,
      showScheduleModal: false,
      showResourcesModal: false,
      selectedIndex: -1,
      showDynamicHelp: false,
    }
  }

  componentDidMount() {
    this.unsubscribe = this.props.firebase
      .getMessageTemplates()
      .onSnapshot((doc) => {
        if (doc.exists) {
          this.setState({
            confirmations: withMultiReservationDefault(
              doc.data().confirmations || DEFAULT_CONFIRMATION_TEMPLATES
            ),
            storedMultiReservation: hasEnabledMultiReservation(doc.data().confirmations),
            loadingTemplates: false,
          })
        } else {
          this.setState({
            loadingTemplates: false,
            confirmations: DEFAULT_CONFIRMATION_TEMPLATES,
            storedMultiReservation: false,
          })
        }
      })
    this.unsubscribeCats = this.props.firebase
      .getResourceCategories()
      .onSnapshot((doc) => {
        if (doc.exists) {
          const resourcecategories = doc.data().categories
          const _categoryOptions = resourcecategories.map((rc) => ({
            value: rc.category.toLowerCase(),
            label: rc.category,
          }))
          _categoryOptions.push({ value: 'all', label: 'Kaikki' })

          this.setState({
            resourcecategories: doc.data().categories,
            categoryOptions: _categoryOptions,
            loadingCategories: false,
          })
        } else {
          this.setState({
            loadingCategories: false,
          })
        }
      })
    this.props.firebase.getResourses().then((_resources) => {
      const resources = _resources.docs
        .map((sh) => {
          return { ...sh.data(), id: sh.id }
        })
        .sort((a, b) => a.displayName.localeCompare(b.displayName))
      if (resources) {
        this.setState({
          resources: resources,
          loadingResources: false,
        })
      } else {
        this.setState({
          resources: [],
          loadingResources: false,
        })
      }
    })
    // getResourses() excludes multiresources; multireservation templates target those instead.
    this.props.firebase.getMultiResources().then((_multiresources) => {
      const multiresources = _multiresources.docs
        .map((sh) => ({ ...sh.data(), id: sh.id }))
        .filter((r) => r.state !== 'deleted')
        .sort((a, b) => (a.displayName || '').localeCompare(b.displayName || ''))
      this.setState({ multiresources })
    })
  }

  // The venue has multiresources but nothing saved would confirm their bookings.
  missingMultiReservation = () =>
    this.state.multiresources.length > 0 && !this.state.storedMultiReservation

  isMultiReservationSelected = () => {
    const selected = this.state.confirmations[this.state.selectedIndex]
    return !!selected && selected.type === MULTIRESERVATION
  }

  // Resources selectable in the Resurssit modal for the currently selected template.
  selectableResources = () => {
    return this.isMultiReservationSelected() ? this.state.multiresources : this.state.resources
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
    if (this.unsubscribeCats) {
      this.unsubscribeCats()
    }
  }

  addConfirmationRow = () => {
    let j = this.state.confirmations
    j.push(JSON.parse(JSON.stringify(INIT_TEMPLATE)))
    this.setState({ confirmations: j })
  }

  toggleMessage = () => {
    this.setState({ showMessageModal: !this.state.showMessageModal })
  }

  toggleSchedule = () => {
    this.setState({ showScheduleModal: !this.state.showScheduleModal })
  }

  toggleResources = () => {
    this.setState({ showResourcesModal: !this.state.showResourcesModal })
  }

  setCategory = (selection) => {
    let _a = this.state.confirmations
    let _s = selection.value
    _a[this.state.selectedIndex].category = _s
    this.setState({ confirmations: _a, saved: false })
  }

  handleMessageBodyChange = (html) => {
    let j = this.state.confirmations
    if (!j[this.state.selectedIndex].message)
      j[this.state.selectedIndex].message = { htmlbody: '', subject: '' }
    j[this.state.selectedIndex].message.htmlbody = html
    delete j[this.state.selectedIndex].message.body
    this.setState({ confirmations: j, saved: false })
  }

  handleMessageSubjectChange = (e) => {
    let j = this.state.confirmations
    if (!j[this.state.selectedIndex].message)
      j[this.state.selectedIndex].message = { body: '', subject: '' }
    j[this.state.selectedIndex].message.subject = e.target.value
    this.setState({ confirmations: j, saved: false })
  }

  handleResourceChange = (e) => {
    let j = this.state.confirmations
    if (!j[this.state.selectedIndex].resources)
      j[this.state.selectedIndex].resources = []
    if (e.target.checked) {
      j[this.state.selectedIndex].resources.push(e.target.name)
    } else {
      j[this.state.selectedIndex].resources = j[
        this.state.selectedIndex
      ].resources.filter((x) => x !== e.target.name)
    }
    this.setState({ confirmations: j, saved: false })
  }

  onSave = (event) => {
    event.preventDefault()
    let _rows = this.state.confirmations.map((r) => {
      delete r.empty
      return r
    })
    this.props.firebase
      .addMessageTemplates({
        confirmations: _rows,
      })
      .then((dataSnapshot) => {
        this.setState({ saved: true })
      })
  }

  handleSelectEvent = (event) => {
    console.log(this.state.confirmations[this.state.selectedIndex].schedule)
    if (window.confirm('Poista ?')) {
      let j = this.state.confirmations
      j[this.state.selectedIndex].schedule = j[
        this.state.selectedIndex
      ].schedule.filter((e) => e.id !== event.id)
      this.setState({ confirmations: j, saved: false })
    }
  }

  handleSelectSlot = (slotInfo) => {
    console.log(slotInfo)
    let s = moment(slotInfo.start)
    let e = moment(slotInfo.end)
    if (e.diff(s, 'minutes') < 30) {
      e = moment(s).add(30, 'minutes')
    }
    let _ePlaceholder = {
      id: uuidv4(),
      start: s.format('HH:mm'),
      end: e.format('HH:mm'),
      day: slotInfo.resourceId,
    }
    let j = this.state.confirmations
    if (!j[this.state.selectedIndex].schedule) j[this.state.selectedIndex].schedule = []
    j[this.state.selectedIndex].schedule.push(_ePlaceholder)
    this.setState({ confirmations: j, saved: false })
  }

  moveEvent = ({ event, start, end, resourceId }) => {
    let j = this.state.confirmations
    j[this.state.selectedIndex].schedule = j[this.state.selectedIndex].schedule.map((e) => {
      if (e.id === event.id) {
        const _s = moment(start)
        const _e = moment(end)
        return { ...e, start: _s.format('HH:mm'), end: _e.format('HH:mm'), day: resourceId }
      } else {
        return e
      }
    })
    this.setState({ confirmations: j, saved: false })
  }

  resizeEvent = ({ event, start, end }) => {
    let j = this.state.confirmations
    j[this.state.selectedIndex].schedule = j[this.state.selectedIndex].schedule.map((e) => {
      if (e.id === event.id) {
        const _s = moment(start)
        const _e = moment(end)
        return { ...e, start: _s.format('HH:mm'), end: _e.format('HH:mm') }
      } else {
        return e
      }
    })
    this.setState({ confirmations: j, saved: false })
  }

  toggleDynamicHelp = () => {
    this.setState({ showDynamicHelp: !this.state.showDynamicHelp })
  }

  render() {
    if (!this.state.loadingCategories && !this.state.loadingTemplates) {
      return (
        <>
          <div className='content'>
            <Row>
              <Col md='12'>
                <Card>
                  <CardHeader>
                    <Row>
                      <Col lg='10' md='5' sm='5'>
                        <CardTitle tag='h5'>Vahvistusviestit</CardTitle>
                      </Col>
                    </Row>
                  </CardHeader>
                  <CardBody>
                    {this.missingMultiReservation() && (
                      <Alert severity='warning' sx={{ mb: 2 }}>
                        Monipaikkavarauksille ei ole tallennettua vahvistusviestiä. Ilman sitä
                        monipaikkavarauksista ei lähetetä vahvistusta. Tarkista Monipaikkavaraus-pohja
                        ja tallenna muutokset.
                      </Alert>
                    )}
                    {this.state.confirmations.map((c, i) => {
                      return (
                        <ConfirmationMessageRow
                          key={i}
                          index={i}
                          template={c}
                          isDefault={c.default}
                          openEditMessageModal={() => {
                            this.setState({ selectedIndex: i })
                            this.toggleMessage()
                          }}
                          openEditScheduleModal={() => {
                            this.setState({ selectedIndex: i })
                            this.toggleSchedule()
                          }}
                          openEditResourcesModal={() => {
                            this.setState({ selectedIndex: i })
                            this.toggleResources()
                          }}
                          updateTemplateName={(e) => {
                            let j = this.state.confirmations
                            j[i].displayName = e.target.value
                            this.setState({ confirmations: j, saved: false })
                          }}
                          updateTemplateType={(selection) => {
                            let j = this.state.confirmations
                            j[i].type = selection.value
                            this.setState({ confirmations: j, saved: false })
                          }}
                          updateTemplateEnabled={(e) => {
                            let j = this.state.confirmations
                            j[i].enabled = e
                            this.setState({ confirmations: j, saved: false })
                          }}
                        />
                      )
                    })}
                    {/* {this.messageTemplateRows()} */}
                    <Row>
                      <Col style={{ marginTop: '20px' }}>
                        <Button
                          className='btn-round btn-icon'
                          color='primary'
                          size='sm'
                          onClick={() => {
                            this.addConfirmationRow()
                          }}
                        >
                          <i className='fa fa-plus' />
                        </Button>{' '}
                        Lisää vahvistusviesti
                      </Col>
                    </Row>
                    <Row>
                      <Col className='ml-auto mr-auto' sm='12'>
                        <Button
                          disabled={this.state.saved && !this.missingMultiReservation()}
                          color='primary'
                          onClick={this.onSave}
                        >
                          Tallenna muutokset
                        </Button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            {/* Message modal */}
            <Modal
              isOpen={this.state.showMessageModal}
              toggle={this.toggleMessage}
              size='lg'
            >
              <ModalHeader toggle={this.toggleMessage}>Viesti</ModalHeader>
              <ModalBody>
              <div>
            <Label for='messagetemplates'>Dynaamiset kentät</Label>
            {this.state.showDynamicHelp ? <KeyboardArrowUpIcon onClick={this.toggleDynamicHelp} /> : <KeyboardArrowDownIcon onClick={this.toggleDynamicHelp} />}
          </div>
          {this.state.showDynamicHelp ? (
          <div>
            <Row>
              <Col>&#123;SUBJECT_SHORT&#125;</Col>
              <Col>Vakiomuotoinen otsikko</Col>
            </Row>
            <Row>
              <Col>&#123;PERSON_NAME&#125;</Col>
              <Col>Asiakkaan etu- ja sukunimi</Col>
            </Row>
            <Row>
              <Col>&#123;RESERVATION_DATE_TIME&#125;</Col>
              <Col>Varauksen päivä ja aika</Col>
            </Row>
            <Row>
              <Col>&#123;RESERVATION_VENUE&#125;</Col>
              <Col>Paikka</Col>
            </Row>
            <Row>
              <Col>&#123;RESERVATION_COURT&#125;</Col>
              <Col>{this.isMultiReservationSelected() ? 'Yhdistetyn kentän nimi' : 'Kenttä'}</Col>
            </Row>
            <Row>
              <Col>&#123;RESERVATION_SPORT&#125;</Col>
              <Col>Kategoria / laji</Col>
            </Row>
            <Row>
              <Col>&#123;RESERVATION_PRICE&#125;</Col>
              <Col>{this.isMultiReservationSelected() ? 'Kokonaishinta ja paikkahinta, esim. 36 € (3 × 12 €)' : 'Hinta'}</Col>
            </Row>
            {this.isMultiReservationSelected() && MULTIRESERVATION_HELP.map(([variable, meaning]) => (
              <Row key={variable}>
                <Col>{variable}</Col>
                <Col>{meaning}</Col>
              </Row>
            ))}
            <Row>
              <Col>&#123;RESERVATION_CODE&#125;</Col>
              <Col>Sisäänpääsykoodi</Col>
            </Row>
            <Row>
              <Col>&#123;RESERVATION_EXTRAS&#125;</Col>
              <Col>Lisätuotteiden vahvistustekstit</Col>
            </Row>
          </div>
            ): null }


                <FormGroup>
                  <Label for='messageSubject'>Otsikko</Label>
                  <Input
                    id='messageSubject'
                    value={
                      this.state.confirmations?.[this.state.selectedIndex]
                        ?.message.subject
                        ? this.state.confirmations[this.state.selectedIndex]
                            ?.message.subject
                        : ''
                    }
                    name='messageSubject'
                    onChange={this.handleMessageSubjectChange}
                  />
                </FormGroup>
                <TinyEditor
                  value={
                    this.state.confirmations?.[this.state.selectedIndex]
                      ?.message.htmlbody
                      ? this.state.confirmations[this.state.selectedIndex]
                          ?.message.htmlbody
                      : this.state.confirmations?.[this.state.selectedIndex]
                          ?.message.body
                      ? this.state.confirmations[
                          this.state.selectedIndex
                        ]?.message.body.replace(/\n/g, '<br/>')
                      : ''
                  }
                  onChange={this.handleMessageBodyChange}
                  onClose={this.handleMessageBodyChange}
                  disableSave={true}
                />
              </ModalBody>
              <ModalFooter>
                <Button
                  color='primary'
                  onClick={() => {
                    this.toggleMessage()
                  }}
                >
                  Sulje
                </Button>
              </ModalFooter>
            </Modal>
            {/* Schedule modal */}
            <Modal
              isOpen={this.state.showScheduleModal}
              toggle={this.toggleSchedule}
              size='xl'
            >
              <ModalHeader toggle={this.toggleSchedule}>Aikataulu</ModalHeader>
              <ModalBody>
                <Row>
                  <Col md='12'>
                    <DnDCalendar
                      style={{ height: '85vh' }}
                      ref={this.myRef}
                      selectable
                      localizer={localizer}
                      events={formatSchedule(this.state.confirmations?.[this.state.selectedIndex]?.schedule || [])}
                      views={['day']}
                      step={30}
                      min={new Date(1970, 0, 1, 23, 0, 0)}
                      defaultView={Views.DAY}
                      scrollToTime={new Date(1970, 0, 1, 12)}
                      defaultDate={new Date(1970, 0, 1, 12)}
                      onSelectEvent={(event) => this.handleSelectEvent(event)}
                      onSelectSlot={this.handleSelectSlot}
                      // onView={this.updateView}
                      components={{ toolbar: PricingToolBar }}
                      // eventPropGetter={this.eventStyleGetter}
                      resources={weekdaysAsResources}
                      resourceIdAccessor='resourceId'
                      resourceTitleAccessor='resourceTitle'
                      draggableAccessor={(event) => true}
                      onEventDrop={this.moveEvent}
                      onEventResize={this.resizeEvent}
                      resizable
                    />
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                <Button
                  color='primary'
                  onClick={() => {
                    this.toggleSchedule()
                  }}
                >
                  Sulje
                </Button>
              </ModalFooter>
            </Modal>
            {/* Resources modal */}
            <Modal
              isOpen={this.state.showResourcesModal}
              toggle={this.toggleResources}
              size='lg'
            >
              <ModalHeader toggle={this.toggleResources}>Resurssit</ModalHeader>
              <ModalBody>
                <div>
                  <p>
                    Valitse kategoria tai yksittäiset resurssit. Jos yksikin
                    resurssi valittu, niin kategoriaa ei huomioida.
                  </p>
                  <div
                    style={{
                      display:
                        this.state.confirmations[this.state.selectedIndex]
                          ?.resources &&
                        this.state.confirmations[this.state.selectedIndex]
                          ?.resources.length > 0
                          ? 'none'
                          : 'block',
                    }}
                  >
                    <Autocomplete
                      id={'catlabel'}
                      options={this.state.categoryOptions}
                      getOptionLabel={(o) => o.label || ''}
                      isOptionEqualToValue={(o, v) => o.value === v.value}
                      disabled={
                        this.state.confirmations[this.state.selectedIndex]?.default ||
                        (this.state.confirmations[this.state.selectedIndex]?.resources &&
                          this.state.confirmations[this.state.selectedIndex]?.resources.length > 0)
                      }
                      value={
                        this.state.confirmations[this.state.selectedIndex]?.category
                          ? this.state.categoryOptions.find(
                              (x) => x.value === this.state.confirmations[this.state.selectedIndex].category
                            ) || null
                          : null
                      }
                      onChange={(_e, val) => this.setCategory(val || { value: 'all', label: 'Kaikki' })}
                      disableClearable
                      renderInput={(params) => (
                        <TextField {...params} label='Kategoria' variant='standard' fullWidth />
                      )}
                    />
                  </div>
                </div>
                <div>
                  <FormControl component='fieldset'>
                    <FormLabel component='legend'>Valitse resurssit</FormLabel>
                    <MuiFormGroup>
                      {this.selectableResources().map((r, i) => {
                        return (
                          <FormControlLabel
                            key={i}
                            control={
                              <Checkbox
                                checked={
                                  this.state.confirmations?.[
                                    this.state.selectedIndex
                                  ]?.resources
                                    ? this.state.confirmations?.[
                                        this.state.selectedIndex
                                      ]?.resources.includes(r.id)
                                    : false
                                }
                                name={r.id}
                                onChange={this.handleResourceChange}
                              />
                            }
                            label={r.displayName}
                          />
                        )
                      })}
                    </MuiFormGroup>
                  </FormControl>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button
                  color='primary'
                  onClick={() => {
                    this.toggleResources()
                  }}
                >
                  Sulje
                </Button>
              </ModalFooter>
            </Modal>
          </div>
{/* Prompt removed in React Router v6 - TODO: implement useBlocker
          <Prompt
            when={!this.state.saved}
            message='Muutoksia ei ole tallennettu. Haluatko varmasti poistua?'
          />
*/}
        </>
      )
    } else {
      return <></>
    }
  }
}

export default ConfirmationMessageTemps
